module.exports = __webpack_public_path__ + "static/media/icons8-health-checkup.9c41d7bf.svg";